<script>
import axios from "axios";

axios.defaults.baseURL = 'https://app.fdc.ug/api';
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';

const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  } else {
    axios.defaults.headers.common["Authorization"] = "";
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  }

import appConfig from "@/app.config";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  mounted() {
  },
  
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
